import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
  // add tootltip arrow to css
  tooltip: {
    width: "174px",
    height: "137px",
    position: "absolute",
    top: 0,
    left: 0,
    padding: "16px",
    backgroundColor: "#fff",
    border: "2px solid #DEDEDE",
    borderRadius: "5px",
    pointerEvents: "none",
    zIndex: 100000,
    boxShadow: "0px 3px 6px #00000029",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 16,
      height: 16,
      bottom: "-17px",
      left: "calc(50%)",
      marginTop: -5,
      boxShadow: `inset -4px -4px 0px -2px ${theme.palette.divider}`,
      backgroundColor: "white",
      transform: "translateY(-50%) translateX(-50%) rotate(45deg)",
    },
  },
  title: {
    fontWeight: "bold",
    marginBottom: "5px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: "12px",
    gap: "12px",
  },
}));

interface ChartTooltipProps {
  title: string;
  children: React.ReactNode;
}

export const ChartTooltip = (props: ChartTooltipProps) => {
  const { title, children } = props;
  return (
    <div className={useStyles().tooltip}>
      <Typography variant="body2" sx={{ fontSize: "14px" }}>
        {title}
      </Typography>
      <div className={useStyles().content}>{children}</div>
    </div>
  );
};
